const TERMINATION_TYPES = [
  'voluntary',
  'involuntary'
];

export default TERMINATION_TYPES;
